import { AsyncTypeahead } from '@xo-union/tk-component-fields';
import React, { useMemo, useState } from 'react';

interface Props {
  name: string;
  label: string;
  defaultInputValue: string;
  onInputChange: (val: string) => void;
  onChange: (val: string) => void;
}

interface GoogleLocations {
  description: string;
}

const GoogleLocationTypeahead: React.FC<Props> = ({ name, label, defaultInputValue, onInputChange, onChange }) => {
  const [locations, setLocations] = useState<string[]>([]);
  const googleClient = useMemo(() => new (window as any).google.maps.places.AutocompleteService(), []);
  const [googleSessionToken, setGoogleSessionToken] = useState(
    new (window as any).google.maps.places.AutocompleteSessionToken()
  );

  const onSearch = (value: string) => {
    if (value && googleSessionToken) {
      googleClient.getPredictions(
        {
          input: value,
          sessionToken: googleSessionToken,
          types: ['(cities)'],
        },
        (response: GoogleLocations[]) => {
          /* Requirement
            US Locs:
            City, State

            Non-US:
            City, Country
          */
          const returnedLocations: string[] = (response || []).map(location =>
            location.description.replace(', USA', '')
          );
          setLocations(returnedLocations);
        }
      );
    } else {
      setLocations([]);
    }
  };

  return (
    <AsyncTypeahead
      name={name}
      label={label}
      defaultInputValue={defaultInputValue}
      suggestions={locations}
      onSearch={onSearch}
      onChange={(val: string) => {
        setGoogleSessionToken(new (window as any).google.maps.places.AutocompleteSessionToken());
        onChange(val);
      }}
      onInputChange={onInputChange}
      data-testid="location-input"
    />
  );
};

export default GoogleLocationTypeahead;
